import { AsHtml } from "../../../utils/translate";
import styles from "./styles.module.scss";

const OfferDiscalimer = ({ title, msg }) => (
  <div className={styles.disclaimerWrapper}>
    <AsHtml className={styles.disclaimerTitle} value={title} />
    <AsHtml className={styles.disclaimerMsg} value={msg} />
  </div>
);

export default OfferDiscalimer;
